import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, TrendingUpIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/offer';
export function Testimonials() {
  return <section className="w-full bg-ink-900 py-20" aria-labelledby="resultados" data-id="element-187" data-mp="3fy30dz1cpy53">
      <div className="mx-auto max-w-5xl px-5" data-id="element-188" data-mp="3azjetzqo6od9">
        <SectionHeading eyebrow="Miembros" title={<span id="resultados" data-id="element-190" data-mp="36zr35e5zc23o">Lo que dicen quienes ya ejecutaron el plan</span>} data-id="element-189" data-mp="3ayqbl8qx6gzv" />

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-191" data-mp="31z3ako23rd7c">
          {testimonials.map((testimonial, index) => <motion.figure key={testimonial.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          delay: index * 0.08
        }} className="flex flex-col rounded-2xl border border-white/10 bg-ink-800 p-7" data-id="element-192" data-mp="2x1bhhqpq1l1k" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-brand-red" aria-hidden="true" data-id="element-193" data-mp="h559pzvzjrw1" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-white/75" data-id="element-194" data-mp="m5b3pmpq9qha">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-5 flex items-center gap-2 text-xs font-bold text-brand-cyan" data-id="element-195" data-mp="79v3t12gv0cz">
                <TrendingUpIcon className="h-4 w-4" aria-hidden="true" data-id="element-196" data-mp="c8y304vrmcd1" />
                {testimonial.result}
              </div>
              <figcaption className="mt-4 border-t border-white/10 pt-4" data-id="element-197" data-mp="14v9be1pm5hke">
                <p className="text-sm font-bold text-white" data-id="element-198" data-mp="14xdeihfoucjm">{testimonial.name}</p>
                <p className="text-xs text-white/45" data-id="element-199" data-mp="q6cvjihbf098">{testimonial.role}</p>
              </figcaption>
            </motion.figure>)}
        </div>

        <p className="mt-8 text-center text-xs leading-relaxed text-white/35" data-id="element-200" data-mp="1iv1yzo5ufho5">
          Los resultados dependen de tu ejecución, tu mercado y tu esfuerzo. No garantizamos
          ingresos.
        </p>
      </div>
    </section>;
}